import { render } from "./ModificaMc1.vue?vue&type=template&id=4fa61938&scoped=true"
import script from "./ModificaMc1.vue?vue&type=script&lang=js"
export * from "./ModificaMc1.vue?vue&type=script&lang=js"

import "./ModificaMc1.vue?vue&type=style&index=0&id=4fa61938&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa61938"]])

export default __exports__